import { css } from "lit";

export const styles = css`
  .image-slide {
    --image-slide-caption-height: var(--size-6);
    width: 100%;
    height: var(--slide-current-height);
    display: flex;
    background-color: var(--color-white);
    box-sizing: border-box;
    flex-direction: column;
    padding: var(--size-4) var(--size-4);
  }

  .title {
    font-size: var(--font-size-6xl);
    line-height: var(--line-height-tight);
    font-weight: var(--font-weight-semibold);
    margin: var(--size-2) var(--size-1);
    display: block;
  }

  .image-container {
    display: flex;
    align-items: center;
    overflow: hidden;
    flex-grow: 1;
    margin: 0 var(--size-1);
  }

  .image-container img {
    height: 100%;
    width: 100%;
    object-fit: contain;
    margin: 0px;
  }

  .mobile,
  .mobile-tall {
    padding: var(--size-4);
  }

  .tall .image-container,
  .mobile-tall .image-container {
    flex-grow: 0;
  }
`;
